module.exports = __webpack_public_path__ + "static/media/alef-rocha.7dcf7b4c.jpg";